(() => {
  'use strict';

  const drawerSelector = 'm-cart-drawer#MinimogCartDrawer, m-cart-drawer';
  let submitting = false;

  const getDrawer = () => document.querySelector(drawerSelector);

  const openDrawer = (trigger) => {
    const drawer = getDrawer();
    if (!drawer) return false;

    if (typeof drawer.open === 'function') {
      drawer.open(trigger || null);
    } else {
      drawer.classList.add('m-cart-drawer--active');
      const panel = drawer.querySelector('.m-cart-drawer__inner');
      drawer.style.setProperty('--m-bg-opacity', '1');
      panel?.style.setProperty('--translate-x', '0');
      document.documentElement.classList.add('prevent-scroll');
    }
    return true;
  };

  const showError = (message) => {
    if (window.MinimogTheme?.Notification?.show) {
      window.MinimogTheme.Notification.show({ type: 'warning', message });
      return;
    }
    console.error(message);
  };

  const updateCount = async () => {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then(r => r.json());
      document.querySelectorAll('.m-cart-count-bubble').forEach((bubble) => {
        bubble.textContent = cart.item_count;
        bubble.classList.toggle('m:hidden', cart.item_count === 0);
        bubble.classList.toggle('hidden', cart.item_count === 0);
      });
    } catch (_) {}
  };

  const addFormWithAjax = async (form, submitter) => {
    if (submitting) return;
    submitting = true;

    const button = submitter || form.querySelector('[type="submit"]');
    const oldDisabled = button?.disabled;
    button?.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;

    try {
      const data = new FormData(form);
      if (!data.get('id')) throw new Error('Please select an available option.');
      if (!data.get('quantity')) data.set('quantity', '1');
      data.set('sections', 'cart-drawer');
      data.set('sections_url', window.location.pathname);

      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'The item could not be added.');

      const drawer = getDrawer();
      if (drawer && typeof drawer.renderContents === 'function' && result.sections) {
        drawer.renderContents(result);
      } else if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
        await drawer.onCartDrawerUpdate();
        openDrawer(button);
        drawer.showAddedConfirmation?.();
      } else {
        openDrawer(button);
      }

      await updateCount();
      document.dispatchEvent(new CustomEvent('amara:cart-added', { detail: result }));
    } catch (error) {
      showError(error.message || 'The item could not be added.');
    } finally {
      submitting = false;
      button?.removeAttribute('aria-busy');
      if (button) button.disabled = Boolean(oldDisabled);
    }
  };

  // Capture cart icon clicks before any theme/app redirect handler runs.
  document.addEventListener('click', (event) => {
    const cartLink = event.target.closest('a.m-cart-icon-bubble, a[href="/cart"], a[href$="/cart"]');
    if (!cartLink || cartLink.closest('.amara-cart-drawer__footer')) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openDrawer(cartLink);
  }, true);

  // Capture every standard Shopify add-to-cart form on homepage, collections and product pages.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const action = new URL(form.action || window.location.href, window.location.origin);
    const isAddForm = action.pathname.endsWith('/cart/add') || action.pathname.endsWith('/cart/add.js');
    if (!isAddForm) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addFormWithAjax(form, event.submitter);
  }, true);
})();
